import React, { useState, useEffect } from 'react';
import './PageTitle.scss';

const PageTitle = ({ title = 'Title', alignment }) => <h1 className={` onboarding-page-title ${alignment} `}>{title}</h1>;

export default PageTitle;
